import styled from 'styled-components'

export const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: .25rem;
  margin-top: .1rem;
`
